export default __webpack_public_path__ + "static/media/2cellEmbryo.3408d638.svg";